import React, {Component} from 'react';
import PageTemplate from 'components/common/PageTemplate';
// import PlusUpContainer from 'containers/guide/PlusUpContainer';

import { Helmet, HelmetProvider } from "react-helmet-async";
import {Link} from 'react-router-dom';
import {
  Package,
  ArrowUpCircle,
  ExternalLink,
  Users,
  CircleQuestionMark
} from 'lucide-react'
import Adsense970250 from 'components/adsense/Adsense970250';
import Adsense300250 from 'components/adsense/Adsense300250';

import styles from './page.scss';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);


class MainPage extends Component {
  render() {
    return (
      <PageTemplate>
        <HelmetProvider>
          <Helmet>
            <title>이터인포</title>
          </Helmet>
          
          <section style={{
            padding: '2rem 1rem',
            textAlign: 'center',
            borderBottom: '1px solid #333'
          }}>
            <h1 style={{
              fontSize: '2rem',
              marginBottom: '1rem',
              fontWeight: 'bold'
            }}>
              이터인포에 오신걸 환영합니다.
            </h1>

            <p style={{
              fontSize: '1rem',
              lineHeight: '1.6',
              color: '#aaa',
              maxWidth: '640px',
              margin: '0 auto'
            }}>
              이터널시티의 아이템, 스탯, 콘텐츠 정보를 확인하고 전투 효율을 계산해보세요.
            </p>
          </section>
          <Adsense970250/>
          
          <section
            style={{
              padding: '1rem 1rem',
              // borderBottom: '1px solid #333',

              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
              gap: '24px',

              maxWidth: '1200px',
              margin: '0 auto'
            }}
          >
            {/* 아이템 정보 */}
            <Link to={`/item`}>
            <div
              className="main-card"
              style={{
                background: '#16161c',
                border: '1px solid rgba(255,255,255,0.12)',
                borderRadius: '14px',
                padding: '20px'
              }}
            >
              <div
                className="main-card__icon"
                style={{
                  width: '44px',
                  height: '44px',
                  borderRadius: '12px',
                  background: 'rgba(120,180,255,0.18)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#9ec1ff',
                  marginBottom: '12px'
                }}
              >
                <Package size={22} />
              </div>
              <h3 style={{ marginBottom: '6px' }}>아이템 정보</h3>
              <p style={{ color: 'rgba(255,255,255,0.7)', fontSize: '13px' }}>
                무기와 아이템의 상세 정보와 스탯을 확인합니다.
              </p>
            </div>
            </Link>
            {/* 플러스업 */}
            <Link to={`/plusup`}>
            <div
              className="main-card"
              style={{
                background: '#16161c',
                border: '1px solid rgba(255,255,255,0.12)',
                borderRadius: '14px',
                padding: '20px'
              }}
            >
              <div
                style={{
                  width: '44px',
                  height: '44px',
                  borderRadius: '12px',
                  background: 'rgba(120,255,180,0.18)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#9cffc1',
                  marginBottom: '12px'
                }}
              >
                <ArrowUpCircle size={22} />
              </div>
              <h3 style={{ marginBottom: '6px' }}>플러스업</h3>
              <p style={{ color: 'rgba(255,255,255,0.7)', fontSize: '13px' }}>
                플러스업 수치에 따른 성능 변화를 확인합니다.
              </p>
            </div>
            </Link>

            {/* 플러스업 */}
            {/* <Link to={`/plusup`}> */}
            <div
              className="main-card"
              style={{
                background: '#16161c',
                border: '1px solid rgba(255,255,255,0.12)',
                borderRadius: '14px',
                padding: '20px'
              }}
            >
              <div
                style={{
                  width: '44px',
                  height: '44px',
                  borderRadius: '12px',
                  background: 'rgba(141, 40, 137, 0.18)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#f59cffff',
                  marginBottom: '12px'
                }}
              >
                <CircleQuestionMark size={22} />
              </div>
              <h3 style={{ marginBottom: '6px' }}>
                {/* 플러스업 */}
              </h3>
              <p style={{ color: 'rgba(255,255,255,0.7)', fontSize: '13px' }}>
                {/* 플러스업 수치에 따른 성능 변화를 확인합니다. */}
              </p>
            </div>
            {/* </Link> */}
            
            {/* 공식 카페 1 */}
            <a
              href="https://cafe.naver.com/eternaltemp/"
              target="_blank"
              rel="noopener noreferrer"
              className="main-card"
              style={{
                background: '#16161c',
                border: '1px solid rgba(255,255,255,0.12)',
                borderRadius: '14px',
                padding: '20px',
                color: 'inherit',
                textDecoration: 'none'
              }}
            >
              <div
                style={{
                  width: '44px',
                  height: '44px',
                  borderRadius: '12px',
                  background: 'rgba(255,200,120,0.18)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#ffd39e',
                  marginBottom: '12px'
                }}
              >
                <Users size={22} />
              </div>
              <h3 style={{ marginBottom: '6px' }}>공식 카페 1</h3>
              <p style={{ color: 'rgba(255,255,255,0.7)', fontSize: '13px' }}>
                이터널시티 공식 커뮤니티 카페입니다.
              </p>
            </a>

            {/* 공식 카페 2 */}
            <a
              href="https://cafe.naver.com/eternaltrade/"
              target="_blank"
              rel="noopener noreferrer"
              className="main-card"
              style={{
                background: '#16161c',
                border: '1px solid rgba(255,255,255,0.12)',
                borderRadius: '14px',
                padding: '20px',
                color: 'inherit',
                textDecoration: 'none'
              }}
            >
              <div
                style={{
                  width: '44px',
                  height: '44px',
                  borderRadius: '12px',
                  background: 'rgba(255,180,180,0.18)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#ffb3b3',
                  marginBottom: '12px'
                }}
              >
                <Users size={22} />
              </div>
              <h3 style={{ marginBottom: '6px' }}>공식 카페 2</h3>
              <p style={{ color: 'rgba(255,255,255,0.7)', fontSize: '13px' }}>
                거래 및 정보 공유 커뮤니티입니다.
              </p>
            </a>

            {/* 공식 홈페이지 */}
            <a
              href="https://eternalcity.mgame.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="main-card"
              style={{
                background: '#16161c',
                border: '1px solid rgba(255,255,255,0.12)',
                borderRadius: '14px',
                padding: '20px',
                color: 'inherit',
                textDecoration: 'none'
              }}
            >
              <div
                style={{
                  width: '44px',
                  height: '44px',
                  borderRadius: '12px',
                  background: 'rgba(180,180,255,0.18)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#b8c6ff',
                  marginBottom: '12px'
                }}
              >
                <ExternalLink size={22} />
              </div>
              <h3 style={{ marginBottom: '6px' }}>공식 홈페이지</h3>
              <p style={{ color: 'rgba(255,255,255,0.7)', fontSize: '13px' }}>
                이터널시티 공식 홈페이지로 이동합니다.
              </p>
            </a>
          </section>
          <section class="center-layout"
            style={{
              maxWidth: '1200px',
              margin: '0 auto',
              padding: '1rem 1rem',

              display: 'grid',
              gridTemplateColumns: '1fr 350px',
              gap: '24px',
              alignItems: 'flex-start'
            }}
          >
            {/* 좌측: 탄창표 */}
            <div
              style={{
                background: '#16161c',
                border: '1px solid rgba(255,255,255,0.12)',
                borderRadius: '14px',
                // padding: '20px'
              }}
            >
              <h3
                style={{
                  marginBottom: '16px',
                  fontSize: '16px',
                  fontWeight: 600,
                  textAlign: 'center'
                }}
              >몬스터 피부에 따른 탄창별 데미지 변화량</h3>
              <table class="tableCombat"><thead><tr><th scope="row"></th><th scope="row">일반</th><th scope="row">연성</th><th scope="row">강성</th><th scope="row">변이</th><th scope="row">장갑형</th><th scope="row" class="end">중장갑형</th></tr></thead><tfoot><tr><td colspan="7">- 추가 데미지 적용 (매우좋음 = +50%, 좋음 = +25%, 보통 = 0%, 나쁨 = -25%, 매우나쁨 = -50%)</td></tr></tfoot><tbody><tr><th scope="col">일반탄</th><td>보통</td><td>보통</td><td>보통</td><td>보통</td><td>나쁨</td><td class="end">매우나쁨</td></tr><tr><th scope="col">소이탄</th><td>보통</td><td class="good">좋음</td><td>나쁨</td><td>보통</td><td>나쁨</td><td class="end">매우나쁨</td></tr><tr><th scope="col">Slug탄</th><td class="good">좋음</td><td>보통</td><td>보통</td><td>나쁨</td><td>나쁨</td><td class="end">매우나쁨</td></tr><tr><th scope="col">철갑탄</th><td>나쁨</td><td>나쁨</td><td class="good">좋음</td><td>나쁨</td><td>보통</td><td class="end">보통</td></tr><tr><th scope="col">열화우라늄</th><td>나쁨</td><td>보통</td><td>보통</td><td class="good">좋음</td><td>나쁨</td><td class="end">매우나쁨</td></tr><tr><th scope="col">유탄</th><td class="good">좋음</td><td class="good">좋음</td><td>나쁨</td><td>나쁨</td><td>매우나쁨</td><td class="end">매우나쁨</td></tr><tr><th scope="col">대인로켓</th><td class="good">매우좋음</td><td class="good">매우좋음</td><td>나쁨</td><td>나쁨</td><td>매우나쁨</td><td class="end">매우나쁨</td></tr><tr><th scope="col">대전차탄</th><td>나쁨</td><td>나쁨</td><td class="good">좋음</td><td class="good">좋음</td><td class="good">좋음</td><td class="end">보통</td></tr><tr><th scope="col">대전차로켓</th><td>나쁨</td><td>나쁨</td><td class="good">좋음</td><td class="good">좋음</td><td class="good">매우좋음</td><td class="end good">좋음</td></tr><tr><th scope="col">중금속탄</th><td class="good">좋음</td><td>나쁨</td><td class="good">좋음</td><td>보통</td><td>나쁨</td><td class="end">나쁨</td></tr></tbody></table>
              {/* 👉 기존 탄창표 table 그대로 여기 넣으면 됨 */}
              {/* <AmmoTable /> 또는 table JSX */}
            </div>

            {/* 우측: 애드센스 */}
            <div
              style={{
                // width: '300px',
                // minHeight: '250px',

                // background: '#111',
                // border: '1px solid rgba(255,255,255,0.12)',
                // borderRadius: '14px',

                // display: 'flex',
                // alignItems: 'center',
                // justifyContent: 'center'
              }}
            >
              {/* 애드센스 컴포넌트 */}
              <Adsense300250 />
            </div>
          </section>      
        </HelmetProvider>
      </PageTemplate>
    );
  }
};

export default MainPage;